import React from 'react';
import style from '../../pages/Ratings/Review.module.scss';
import { usePopup } from '../../hooks';
import styles from '../../styles/Accordion.module.scss';

const ConfirmationDialog = () => {
  const buttons = ['Cancel', 'Exit'];
  const [setPopup] = usePopup();
  const handleConfirmation = (i) => {
    if (i === 0) {
      setPopup({ open: true, popupType: '' });
    } else if (i === 1) {
      window.location = 'https://www.justdial.com';
    }
  };
  const handleClosePopUp = () => {
    setPopup({ open: true, popupType: '' });
  };
  return (
    <section className="cs_modal_feedback undefined">
      <div className="cs_modal_feedback_content cs_modal_animation fadeInUpTop">
        <div className="cs_modal_body p-10">
          <div className="cs_modal_feedback_close mt-10">
            <div
              className={`${style.HeadClose} modal_close csicon`}
              onClick={() => handleClosePopUp()}
              aria-label="Close Modal"
              type="button"
              tabIndex={0}
              role="button"
              onKeyDown={() => handleClosePopUp()}
            />
          </div>
          <div className="FeedbackModal_FeedbackModal__Box__BAgpO">
            <div className="font16 fw600 color111 mt-5 pb-20">Would you like to submit rating before leaving?</div>
            <div className="font12 fw400 color111 mt-5 pb-20">Note: This page will expire on exit.</div>
            <div className={`${style.flexContainer}`}>
              {buttons.map((button, i) => (
                <button
                  type="button"
                  className={`${styles.Accordion__Contant__Button} bluefill_animate font14 fw600 colorFFF`}
                  style={{
                    backgroundColor: '#0076D7',
                    border: '1px solid #E0E0E0',
                    transitionProperty: 'background-color, background-image, border-color, box-shadow',
                    transition: 'all 0.8s',
                    color: `#FFFFFF`,
                    width: '100px',
                  }}
                  key={i}
                  onClick={() => handleConfirmation(i)}
                >
                  {button}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConfirmationDialog;
